module.exports = __webpack_public_path__ + "static/cinsa_home_tu_calentador_ideal_deposito_XLG-412ee04906e4051c9be2cac9e0186844.png";